module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\"><path d=\"M7 18v-8H4V7h3V4.5C7.1 2.9 8 1 10 1h3v3h-3v3h3v3h-3v8H7z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/facebook.svg
// module id = 43
// module chunks = 0